import { useMemo } from 'react'
import { graphql } from 'relay-runtime'
import { useFragment } from 'react-relay'

import { deltaAsPercent } from '../../../../display'
import {
  ThemeInsight_InsightV2$key,
  LabelType,
} from './__generated__/ThemeInsight_InsightV2.graphql'
import { Bubble, BubbleProps } from '../../../../components/Bubble/Bubble'

export const themeInsightsFragment = graphql`
  fragment ThemeInsight_InsightV2 on InsightV2 {
    id
    labelName
    delta
    rateWhenAbsent
    clusteredSublabels {
      labelName
      labelLift
      labelType
    }
  }
`

type ThemeInsightsProps = {
  fragmentKey: ThemeInsight_InsightV2$key
}

export const ThemeInsight = ({ fragmentKey }: ThemeInsightsProps) => {
  const data = useFragment(themeInsightsFragment, fragmentKey)

  const statValue = useMemo(() => {
    // if (data.labelLift) {
    //   const mod = data.labelLift > 0 ? '+' : '-'

    //   return `${mod} ${Math.abs(data.labelLift).toFixed(2)}%`
    // } else
    if (data.delta && data.rateWhenAbsent) {
      const mod = data.delta > 0 ? '+' : '-'

      return `${mod} ${deltaAsPercent(
        Math.abs(data.delta / data.rateWhenAbsent)
      )}%`
    } else {
      return '-'
    }
  }, [data.delta, data.rateWhenAbsent])

  const statBubbleVariant = useMemo(() => {
    let val = data.delta
    // || data.labelLift
    if (!val) return 'grey'

    return val > 0 ? 'green' : 'red'
  }, [data.delta])

  return (
    <div className="flex w-1/3 flex-none flex-col gap-3 rounded border-b border-gray-200 bg-white p-3 shadow-lg">
      <div className="flex items-center justify-between">
        <p className="text-lg uppercase text-black">{data.labelName}</p>
        <Bubble variant={statBubbleVariant} className="rounded-lg">
          {statValue}
        </Bubble>
      </div>

      <h2 className="text-sm">Sub labels:</h2>
      <div className="flex max-h-48 flex-wrap gap-2 overflow-auto">
        {[...(data.clusteredSublabels || [])].sort(byLabelLift).map((label) => (
          <Bubble
            variant={labelTypeColors[label.labelType]}
            className="rounded"
          >
            <span className="whitespace-nowrap">
              <span>&quot;{label.labelName}&quot; : </span>
              <strong>
                {label.labelLift > 0 ? '+' : ''}
                {label.labelLift}%
              </strong>
            </span>
          </Bubble>
        ))}
      </div>
    </div>
  )
}

export const labelTypeColors: Record<LabelType, BubbleProps['variant']> = {
  NOUN: 'grey',
  VERB: 'grey',
  PHRASE: 'grey',
  IMAGE: 'lightBlue',
  VIDEO: 'darkBlue',
  DOMINANT_COLOR: 'lightBlue',
  THEME: 'grey',
  HOOK_TEXT: 'grey',
  TAG: 'grey',
  HEADLINE: 'grey',
  '%future added value': 'grey',
}

interface SortableSublabel {
  labelLift: number
}
function byLabelLift(a: SortableSublabel, b: SortableSublabel) {
  return a.labelLift > b.labelLift ? -1 : 1
}
